import { render, staticRenderFns } from "./DepositsReports.component.vue?vue&type=template&id=35988232&scoped=true&"
import script from "./DepositsReports.component.vue?vue&type=script&lang=js&"
export * from "./DepositsReports.component.vue?vue&type=script&lang=js&"
import style0 from "./DepositsReports.component.vue?vue&type=style&index=0&id=35988232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35988232",
  null
  
)

export default component.exports